import { render, staticRenderFns } from "./OrgDialog.vue?vue&type=template&id=0261d5b0&"
import script from "./OrgDialog.vue?vue&type=script&lang=js&"
export * from "./OrgDialog.vue?vue&type=script&lang=js&"
import style0 from "./OrgDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports